import { z } from "zod";
export const createTenantAppSchema = z.object({
    companyId: z.string().uuid(),
    name: z.string().min(1).max(200),
    description: z.string().max(5000).optional(),
    framework: z.string().max(100).optional(),
    builtByAgentId: z.string().uuid().optional(),
    visibility: z.enum(["agents-only", "internal", "public"]).default("internal"),
    healthEndpoint: z.string().max(500).default("/health"),
    sourceRepo: z.string().max(500).optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const updateTenantAppSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(5000).optional(),
    framework: z.string().max(100).optional(),
    status: z.enum(["draft", "building", "deployed", "failed", "stopped"]).optional(),
    visibility: z.enum(["agents-only", "internal", "public"]).optional(),
    buildPhase: z.enum(["requirements", "planning", "building", "testing", "review", "deploying", "deployed", "handed_over"]).optional(),
    handoverNotes: z.string().max(10000).optional(),
    healthEndpoint: z.string().max(500).optional(),
    customDomain: z.string().max(500).optional(),
    sourceRepo: z.string().max(500).optional(),
    sourcePath: z.string().max(1000).optional(),
    devServerPort: z.number().int().min(1024).max(65535).optional(),
    devServerStatus: z.enum(["starting", "running", "stopped", "failed"]).optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const deployTenantAppSchema = z.object({
    version: z.string().max(100).optional(),
    sourcePath: z.string().min(1).max(1000),
    startupCommand: z.string().max(1000).optional(),
    envVars: z.record(z.string()).optional(),
});
export const promoteTenantAppSchema = z.object({
    version: z.string().max(100).optional(),
    sourcePath: z.string().min(1).max(1000).optional(),
    startupCommand: z.string().max(1000).optional(),
    runtime: z.string().max(100).optional(),
    envVars: z.record(z.string()).optional(),
});
export const toggleAppVisibilitySchema = z.object({
    visibility: z.enum(["agents-only", "internal", "public"]),
});
export const handoverAppSchema = z.object({
    notes: z.string().max(10000).optional(),
});
//# sourceMappingURL=tenant-app.js.map